import { PropertyContext, useBoardContext } from "@rastreabilidadebrasil/tageditor";
import * as properties from "./properties";
import { useTranslation } from "react-i18next";

function PropertyBar() {
  const { board } = useBoardContext();
  const hasSelection = board?.activeObjects && board.activeObjects.length > 0;
  const { t } = useTranslation("editor");

  if (!hasSelection) return null;

  return (
    <div className="property-bar-sidebar">
      <div
        className="property-bar-sidebar-header"
        style={{ backgroundColor: "#333333", color: "white", textAlign: "center" }}
      >
        <span> {t("Propriedades do objeto")}</span>
      </div>
      <div className="property-bar-sidebar-content">
        <PropertyContext componentCollection={properties} />
      </div>
    </div>
  );
}

export default PropertyBar;
